import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  CircularProgress,
  Typography,
  keyframes,
  Box,
} from "@mui/material";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const PendingToken = ({ data, pendingValue, isLoading, selectedServiceId }) => {
  const [isDelayedLoading, setIsDelayedLoading] = useState(true);
  const currentDepartment = Cookies.get("DepId");

  useEffect(() => {
    const delayTimer = setTimeout(() => {
      setIsDelayedLoading(false);
    }, 1000);
    return () => clearTimeout(delayTimer);
  }, [isLoading]);

  if (isLoading || isDelayedLoading) {
    return (
      <Paper
        className="flex"
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          borderRadius: "16px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <CircularProgress
            size={60}
            thickness={4}
            sx={{
              animation: `${spin} 1s linear infinite`,
              color: "primary.main",
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "text.primary",
              fontSize: "1.5rem",
            }}
          >
            Loading Tokens
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              fontSize: "1rem",
            }}
          >
            Please wait while we fetch the data...
          </Typography>
        </Box>
      </Paper>
    );
  }

  const filteredTokens = (data?.data?.tokensOnPending || []).filter((token) => {
  if (!selectedServiceId) return true;
  const serviceId = Number(selectedServiceId);
  return token.ServiceID === serviceId;
});

//   const tokensArray = data?.data?.tokensOnPeding;
// const filteredTokens = Array.isArray(tokensArray) 
//   ? tokensArray.filter((token) => {
//       if (!selectedServiceId) return true;
//       const serviceId = Number(selectedServiceId);
//       return token.ServiceID === serviceId;
//     })
//   : [];


  const evenTokens = filteredTokens?.filter((item, index) => index % 2 === 0);
  const oddTokens = filteredTokens?.filter((item, index) => index % 2 === 1);
  const oddTokenDepId = filteredTokens?.find(
    (_, index) => index % 2 === 0
  )?.DepId;
  const evenTokenDepId = filteredTokens?.find(
    (_, index) => index % 2 === 1
  )?.DepId;

  if (isLoading) {
    return (
      <Paper
        className="flex"
        sx={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          height: 200,
        }}
      >
        <CircularProgress />
        <Typography variant="body1" sx={{ marginTop: 2 }}>
          Loading tokens...
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper className="flex" sx={{ width: "100%" }}>
      <TableContainer sx={{ maxHeight: 440 }} className="flex">
        <Table>
          <TableBody>
            {evenTokens?.map((evenTokens, index) => {
              const isDifferentDep =
                evenTokens.DepID !== parseInt(currentDepartment);
              return (
                <TableRow key={index + 1}>
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontSize: "25px",
                      fontWeight: "bold",
                      verticalAlign: "top",
                      borderRightWidth: "1px",
                    }}
                    onClick={() =>
                      pendingValue({
                        val: evenTokens.TokenValue,
                        prefix: evenTokens.DepPrefix,
                        DepId: evenTokens.DepID,
                        TokenID: evenTokens.TokenID,
                        ServiceID: evenTokens.ServiceID,
                      })
                    }
                  >
                    <div
                      style={{
                        backgroundColor: isDifferentDep
                          ? "#ffcccc"
                          : "transparent",
                        padding: "5px",
                        borderRadius: "5px",
                        width: "100%",
                      }}
                    >
                      {`${evenTokens?.DepPrefix || Cookies.get("DepPrefix")}${
                        evenTokens.TokenValue
                      }`}
                      {Cookies.get("isServiceEnable") === "true" ? (
                        <div
                          style={{
                            fontSize: "15px",
                            fontWeight: "normal",
                          }}
                        >
                          {evenTokens?.ServiceName || ""}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Table>
          <TableBody>
            {oddTokens?.map((oddTokens, index) => {
              const isDifferentDep =
                oddTokens.DepID !== parseInt(currentDepartment);
              return (
                <TableRow key={index + 1}>
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontSize: "25px",
                      fontWeight: "bold",
                      verticalAlign: "top",
                      borderLeftWidth: "1px",
                    }}
                    onClick={() =>
                      pendingValue({
                        val: oddTokens.TokenValue,
                        prefix: oddTokens.DepPrefix,
                        DepId: oddTokens.DepID,
                        TokenID: oddTokens.TokenID,
                        ServiceID: evenTokens.ServiceID,
                      })
                    }
                  >
                    {/* {oddTokens.TokenValue} */}
                    <div
                      style={{
                        backgroundColor: isDifferentDep
                          ? "#ffcccc"
                          : "transparent",
                        padding: "5px",
                        borderRadius: "5px",
                        width: "100%",
                      }}
                    >
                      {`${oddTokens?.DepPrefix || Cookies.get("DepPrefix")}${
                        oddTokens.TokenValue
                      }`}
                      {Cookies.get("isServiceEnable") === "true" ? (
                        <div
                          style={{
                            fontSize: "15px",
                            fontWeight: "normal",
                          }}
                        >
                          {oddTokens?.ServiceName || ""}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default PendingToken;
